module.exports = __webpack_public_path__ + "img/IT.f04de15f.svg";